import { Tag } from 'antd';
import { AppTagColor } from 'config/utils/catalog.util';
import React from 'react';
import styles from './style.module.scss';

type AppTagProps = {
  text: string;
  closeIcon?: React.ReactNode;
  color?: AppTagColor;
  contentIcon?: React.ReactNode;
  withBorder?: boolean;
  onClose?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

const AppTag: React.FC<AppTagProps> = ({
  text = '<TEXT_HERE>',
  closeIcon = null,
  color = AppTagColor.PROCESSING,
  contentIcon = null,
  withBorder = true,
  onClose = () => {},
}) => {
  return (
    <div className={styles['app-tag']}>
      <Tag
        icon={contentIcon}
        bordered={withBorder}
        color={color}
        onClose={onClose}
        closeIcon={closeIcon}
        style={{ width: '100%', textAlign: 'center' }}
      >
        {text}
      </Tag>
    </div>
  );
};

export default AppTag;
